import { render, staticRenderFns } from "./BannerAd.vue?vue&type=template&id=362e49d2"
import script from "./BannerAd.vue?vue&type=script&lang=js"
export * from "./BannerAd.vue?vue&type=script&lang=js"
import style0 from "./BannerAd.vue?vue&type=style&index=0&id=362e49d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports